export default {
    qiwei_yuangong_num: '', // //  BJR1102  BJR1370
    codefalse: 1, //  面访开关
    active2: 0,
    headers: {
        'lshm-work-wechat-token': '9VuyZdPwExJ1F765n2gcrkeTCY0ofbiqISU8ljMzRvOtDQABhN',
    }

}


// WEBPACK FOOTER //
// ./src/config.js